import { updatedDiff } from '@helpers/data';

import {
  WITHDRAWALS_AGGREGATOR_STATE,
  WithdrawalsDistributionSettingsItems,
} from '@types';

import { WithdrawalsSetAggregatorStateReducer } from './types';

export const withdrawalsSetAggregatorStateReducer: WithdrawalsSetAggregatorStateReducer =
  (state, action) => {
    const { aggregatorId, aggregatorState } = action.payload;

    const isPaymentSystemsStatesSave =
      aggregatorState === WITHDRAWALS_AGGREGATOR_STATE.ENABLED;

    if (
      !state.withdrawalsDistributionSettingsProcessedItems ||
      !state.withdrawalsDistributionSettingsItems
    ) {
      return state;
    }

    let processed: Partial<WithdrawalsDistributionSettingsItems>;

    if (isPaymentSystemsStatesSave) {
      processed = {
        ...state.withdrawalsDistributionSettingsProcessedItems,
        [aggregatorId]: {
          ...state.withdrawalsDistributionSettingsProcessedItems[aggregatorId],
          aggregatorState,
        },
      };
    } else {
      processed = {
        ...state.withdrawalsDistributionSettingsProcessedItems,
        [aggregatorId]: {
          ...state.withdrawalsDistributionSettingsProcessedItems[aggregatorId],
          aggregatorState,
          paymentSystems: {
            ...state.withdrawalsDistributionSettingsItems[aggregatorId],
          },
        },
      };
    }

    const changes = updatedDiff(
      state.withdrawalsDistributionSettingsItems,
      processed
    );

    return {
      ...state,
      withdrawalsDistributionSettingsProcessedItems: {
        ...changes,
      },
    };
  };
